"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var IconLinkBlock = function IconLinkBlock(_ref) {
  var icon = _ref.icon,
      iconType = _ref.iconType,
      iconTopOffset = _ref.iconTopOffset,
      iconLeftOffset = _ref.iconLeftOffset,
      label = _ref.label,
      onClick = _ref.onClick,
      active = _ref.active,
      disabled = _ref.disabled,
      className = _ref.className,
      otherProps = _ref.otherProps,
      info = _ref.info;
  return /*#__PURE__*/_react.default.createElement(StyledIconLinkBlock, _extends({
    onClick: disabled ? null : onClick,
    active: active,
    disabled: disabled,
    iconType: iconType,
    className: className
  }, otherProps), icon ? /*#__PURE__*/_react.default.createElement(IconWrapper, {
    iconTopOffset: iconTopOffset,
    iconLeftOffset: iconLeftOffset
  }, icon) : null, label ? /*#__PURE__*/_react.default.createElement(Label, {
    info: info
  }, label) : null, info ? /*#__PURE__*/_react.default.createElement(Info, null, info) : null);
};

var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "IconWrapper"
})(["position:absolute;top:", ";left:", ";> svg path{transition:fill 0.15s ease-in-out,stroke 0.15s ease-in-out;}"], function (_ref2) {
  var iconTopOffset = _ref2.iconTopOffset;
  return iconTopOffset ? iconTopOffset : '0.5rem';
}, function (_ref3) {
  var iconLeftOffset = _ref3.iconLeftOffset;
  return iconLeftOffset ? iconLeftOffset : '0.5rem';
});

var Label = _styledComponents.default.div.withConfig({
  displayName: "Label"
})(["position:absolute;bottom:", ";left:1.6rem;font-weight:500;font-size:1.8rem;line-height:120%;color:#222;transition:color 0.15s ease-in-out;"], function (_ref4) {
  var info = _ref4.info;
  return info ? '4.6rem' : '1.6rem';
});

var Info = _styledComponents.default.div.withConfig({
  displayName: "Info"
})(["position:absolute;margin-right:1rem;bottom:1.6rem;left:1.6rem;color:#8990a3;font-size:1.2rem;line-height:120%;"]);

var StyledIconLinkBlock = _styledComponents.default.div.withConfig({
  displayName: "StyledIconLinkBlock"
})(["position:relative;font-family:", ";width:100%;padding-top:100%;background-color:", ";border:1px solid ", ";box-shadow:0 0 1px rgba(0,0,0,0.04),0 0 2px rgba(0,0,0,0.06),0 4px 8px rgba(0,0,0,0.04);border-radius:0.5rem;cursor:", ";transition:box-shadow 0.15s ease-in-out;", "{> svg path{fill:", ";stroke:", ";}}", "{color:", ";}&:hover{box-shadow:", ";", "{> svg path{fill:", ";stroke:", ";}}}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.font;
}, function (_ref6) {
  var theme = _ref6.theme,
      active = _ref6.active,
      disabled = _ref6.disabled;
  return disabled ? '#f0f1f3' : active ? theme.brand.primary : 'white';
}, function (_ref7) {
  var theme = _ref7.theme,
      active = _ref7.active,
      disabled = _ref7.disabled;
  return disabled ? '#f0f1f3' : active ? theme.brand.primary : '#f0f1f3';
}, function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, IconWrapper, function (_ref9) {
  var active = _ref9.active,
      disabled = _ref9.disabled,
      iconType = _ref9.iconType;
  return disabled && iconType === 'fill' ? '#D4D4D4' : active && iconType === 'fill' ? 'white' : iconType === 'fill' ? '#D4D4D4' : null;
}, function (_ref10) {
  var active = _ref10.active,
      disabled = _ref10.disabled,
      iconType = _ref10.iconType;
  return disabled && iconType === 'stroke' ? '#D4D4D4' : active && iconType === 'stroke' ? 'white' : iconType === 'stroke' ? '#D4D4D4' : null;
}, Label, function (_ref11) {
  var active = _ref11.active,
      disabled = _ref11.disabled;
  return disabled ? '#D4D4D4' : active ? 'white' : '#222';
}, function (_ref12) {
  var disabled = _ref12.disabled;
  return disabled ? "0 0 1px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.06),\n    0 4px 8px rgba(0, 0, 0, 0.04)" : "0 0 1px rgba(0, 0, 0, 0.04), 0 4px 8px rgba(0, 0, 0, 0.04),\n      0 16px 24px rgba(0, 0, 0, 0.04), 0 24px 32px rgba(0, 0, 0, 0.04)";
}, IconWrapper, function (_ref13) {
  var theme = _ref13.theme,
      iconType = _ref13.iconType,
      active = _ref13.active,
      disabled = _ref13.disabled;
  return disabled && iconType === 'fill' ? '#D4D4D4' : active && iconType === 'fill' ? 'white' : iconType === 'fill' ? theme.brand.primary : null;
}, function (_ref14) {
  var theme = _ref14.theme,
      iconType = _ref14.iconType,
      active = _ref14.active,
      disabled = _ref14.disabled;
  return disabled && iconType === 'stroke' ? '#D4D4D4' : active && iconType === 'stroke' ? 'white' : iconType === 'stroke' ? theme.brand.primary : null;
});

IconLinkBlock.defaultProps = {
  iconType: 'fill'
};
IconLinkBlock.propTypes = {
  /** If an element is passed here, it will be displayed in the top left corner of the element. */
  icon: _propTypes.element,

  /** Defines wether an icon is made up of strokes or fill. (Needed for coloring of the SVG.) TYPES = "fill" / "stroke" */
  iconType: _propTypes.string,

  /** Due to the way wg-fe-ui icons are implemented, a top offset might be needed to align the icon correctly. */
  iconTopOffset: _propTypes.string,

  /** Due to the way wg-fe-ui icons are implemented, a left offset might be needed to align the icon correctly. */
  iconLeftOffset: _propTypes.string,

  /** A label to be displayed at the bottom of the element. */
  label: _propTypes.string.isRequired,

  /** onClick function to be executed when the element is clicked. */
  onClick: _propTypes.func.isRequired,

  /** Defines wether the element is in it's active state or not. */
  active: _propTypes.bool,

  /** Defines wether the element is disabled or not. */
  disabled: _propTypes.bool,

  /** Extra classnames to be passed to the element. */
  className: _propTypes.string,

  /** Extra props to be passed to the element. */
  otherProps: _propTypes.object
};
var _default = IconLinkBlock;
exports.default = _default;